import { createComponent } from '@carvana/merch-components';

export const Footer = createComponent('footer', {
  className:
    'flex flex-col gap-y-4xl bg-background-muted-strong px-2xl py-8xl text-text-primary-subtle t-body-sm md:px-[84px]'
});

export const LinksOuterWrapper = createComponent('div', {
  className: 'grid grid-cols-2 gap-x-2xl gap-y-4xl md:flex md:flex-col'
});

export const LinksWrapper = createComponent('div', {
  className: 'flex flex-col gap-y-xl'
});

export const Heading = createComponent('p', { className: 't-heading-sm' });

export const HoursHeading = createComponent('p', {
  className: 't-heading-xs'
});

export const Hours = createComponent('div', {
  className: 'grid grid-cols-2 gap-x-xl gap-y-8'
});

export const Divider = createComponent('hr', {
  className: 'h-[1px] bg-border-inverse-transparent'
});
